import { createZustandStore } from '../../zustand';
import { IUseUILayoutState } from './types';

/**
 * This creates a local global header height state
 * to track header height changes for both collapsed and expanded header.
 */
export const useUILayoutStore = createZustandStore<IUseUILayoutState>()(
  (set) => ({
    dynamicHeaderHeight: 0,
    updateScreenHeaderHeight: (dynamicHeaderHeight: number) => {
      set(() => ({ dynamicHeaderHeight }));
    },
  })
);
